module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d87d7b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-awesome-swiper/slide.vue
// module id = 233
// module chunks = 1